export default __webpack_public_path__ + "static/media/yellow-candy.a3d87a9b.png";